var map = {
	"./TURBO_Logo_RGB.svg": 70928,
	"./favicon/android-icon-144x144.png": 76507,
	"./favicon/android-icon-192x192.png": 93762,
	"./favicon/android-icon-36x36.png": 6894,
	"./favicon/android-icon-48x48.png": 32155,
	"./favicon/android-icon-72x72.png": 77344,
	"./favicon/android-icon-96x96.png": 46562,
	"./favicon/apple-icon-114x114.png": 69618,
	"./favicon/apple-icon-120x120.png": 97072,
	"./favicon/apple-icon-144x144.png": 10341,
	"./favicon/apple-icon-152x152.png": 28583,
	"./favicon/apple-icon-180x180.png": 52791,
	"./favicon/apple-icon-57x57.png": 84222,
	"./favicon/apple-icon-60x60.png": 89877,
	"./favicon/apple-icon-72x72.png": 26189,
	"./favicon/apple-icon-76x76.png": 18857,
	"./favicon/apple-icon-precomposed.png": 45522,
	"./favicon/apple-icon.png": 41683,
	"./favicon/favicon-16x16.png": 79231,
	"./favicon/favicon-32x32.png": 4216,
	"./favicon/favicon-96x96.png": 89795,
	"./favicon/favicon.ico": 4763,
	"./favicon/ms-icon-144x144.png": 88559,
	"./favicon/ms-icon-150x150.png": 3452,
	"./favicon/ms-icon-310x310.png": 93427,
	"./favicon/ms-icon-70x70.png": 92625,
	"./gdpr.pdf": 47053,
	"./ic_card.svg": 68688,
	"./ic_fb.svg": 93792,
	"./ic_insta.svg": 97286,
	"./ic_kosik1.svg": 66531,
	"./ic_kosik2.svg": 33147,
	"./ic_phone.svg": 12594,
	"./ic_place.svg": 46407,
	"./ic_posta.svg": 53599,
	"./pizza.gif": 79138,
	"./roadblock.gif": 62589,
	"./squares.svg": 55960,
	"./triangles.svg": 35472,
	"./turbo_car.png": 81073,
	"./turbo_car_delivery.png": 97001,
	"./turbo_car_inhouse.png": 6098,
	"./vop.pdf": 46082,
	"./xMenu.svg": 91855
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41544;